module.exports = __webpack_public_path__ + "Group 15717.a2c54c9c17bf70763c3c.png";